if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper ? this.productWrapper.querySelector('.product-images') : null;
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.loadRestockDataByVariant();
      this.getInventoryByLocation();
      this.updateMyWarehouseLink();
      this.initInventoryAccordion();
      this.initInventoryByLocationGroupClicks();
      
      // Listen for changes to selectedLocation in localStorage
      // Storage event only fires for changes in other windows/tabs
      window.addEventListener('storage', (e) => {
        if (e.key === 'selectedLocation') {
          this.updateMyWarehouseLink();
        }
      });
      
      // Listen for custom event when location changes in same window
      document.addEventListener('warehouse:location-changed', () => {
        this.updateMyWarehouseLink();
      });
    }

    initInventoryAccordion() {
      // Find the inventory section - it should be in the same section as this component
      const section = this.closest('section');
      if (!section) return;
      
      const contentElement = section.querySelector('.inventory-by-location__content');
      if (!contentElement) return;
      
      // Check if already initialized
      if (contentElement.dataset.accordionInitialized === 'true') return;
      
      const headingButton = contentElement.querySelector('.inventory-by-location__content-heading');
      if (!headingButton) return;
      
      headingButton.addEventListener('click', () => {
        contentElement.classList.toggle('open');
      });
      
      // Mark as initialized
      contentElement.dataset.accordionInitialized = 'true';
    }

    initInventoryByLocationGroupClicks() {
      const container = document.getElementById(`inventory-by-location-${this.dataset.section}`);
      if (!container || container.dataset.warehouseGroupHandlerAdded === 'true') return;

      container.addEventListener('click', (e) => {
        const group = e.target.closest('.inventory-by-location__group');
        if (!group || !container.contains(group)) return;

        const labelSpan = group.querySelector('.inventory-by-location__group-header span');
        const rawLabel = (labelSpan?.textContent || '').trim();
        const groupLabel = rawLabel.replace(/:$/, '').trim();

        this.openWarehouseSelectorModal(groupLabel);
      });

      container.dataset.warehouseGroupHandlerAdded = 'true';
    }

    openWarehouseSelectorModal(preferredLocationLabel = null) {
      const modal = document.getElementById('warehouseSelectorModal');

      if (modal && preferredLocationLabel) {
        modal.dataset.preferredLocationLabel = preferredLocationLabel;
      }

      const warehouseSelectorButton = document.querySelector('.warehouse-selector');
      if (warehouseSelectorButton) {
        warehouseSelectorButton.click();
        return;
      }

      if (modal) {
        modal.classList.add('open');
      }
    }

    loadRestockDataByVariant() {
      const scriptElement = document.getElementById(`restock-data-${this.dataset.section}`);
      if (scriptElement) {
        try {
          this.restockData = JSON.parse(scriptElement.textContent);
        } catch (error) {
          console.error('Error parsing restock data:', error);
          this.restockData = null;
        }
      } else {
        this.restockData = null;
      }
    }

    getRestockDataForCurrentVariant() {
      return this.restockData || null;
    }

    onVariantChange(event) {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();
      this.updateOther();
      this.renderProductInfo(event);
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.optionValueIds = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          const select = fieldset.querySelector('select');
          this.options.push(select.value);
          this.optionValueIds.push(select.selectedOptions[0] && select.selectedOptions[0].dataset.optionValueId);
        } else if (fieldset.querySelectorAll('input').length) {
          const checked = fieldset.querySelector('input:checked');
          if (!checked) return;
          this.options.push(checked.value);
          this.optionValueIds.push(checked.dataset.optionValueId);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getServerSelectedVariant();
      if (this.currentVariant) return;

      const variants = this.getVariantData();
      if (variants.length === 1) {
        this.currentVariant = variants[0];
        return;
      }
      if (!this.options || !this.options.length) return;

      this.currentVariant = variants.find((variant) => {
        return variant.options && !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      }) || null;
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateVariantText();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let activeMedia = productSlider.querySelector(mediaId);
      if (productSlider.flkty && this.hideVariants) {

        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.flkty.selectCell(mediaId);

      } else if (productSlider.flkty) {
        productSlider.flkty.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const variantId = this.currentVariant?.id ?? '';
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky, #product-form--sticky, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        this.syncOversizedProperty(productForm);
        this.syncMaterialProperty(productForm);
      });
    }

    getMaterialPropertyName(material) {
      const value = typeof material === 'string' ? material : JSON.stringify(material || '');
      const normalized = value.toLowerCase();
      if (normalized.includes('polyrock')) return 'material_polyrock';
      if (normalized.includes('vulkaponic')) return 'material_vulkaponic';
      if (normalized.includes('leca')) return 'material_leca';
      if (normalized.includes('fiberclay') || normalized.includes('fiber clay')) return 'material_fiberclay';
      return null;
    }

    getSelectedVariantShippingData() {
      const el = this.querySelector('[data-variant-shipping-properties]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    syncMaterialProperty(productForm) {
      const data = this.getSelectedVariantShippingData();
      const propertyName = this.getMaterialPropertyName(data?.material);
      let materialInput = productForm.querySelector('[data-variant-material-property]');

      if (propertyName) {
        const inputName = `properties[${propertyName}]`;
        if (!materialInput) {
          materialInput = document.createElement('input');
          materialInput.type = 'hidden';
          materialInput.dataset.variantMaterialProperty = '';
          productForm.appendChild(materialInput);
        }
        materialInput.name = inputName;
      } else if (materialInput) {
        materialInput.remove();
      }
    }

    syncOversizedProperty(productForm) {
      const isOversized = Boolean(this.getSelectedVariantShippingData()?.oversized);
      let oversizedInput = productForm.querySelector('input[name="properties[oversized]"]');

      if (isOversized && !oversizedInput) {
        oversizedInput = document.createElement('input');
        oversizedInput.type = 'hidden';
        oversizedInput.name = 'properties[oversized]';
        oversizedInput.value = 'true';
        productForm.appendChild(oversizedInput);
      } else if (!isOversized && oversizedInput) {
        oversizedInput.remove();
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getCollapsibleTabsToRender() {
      return Array.from(document.querySelectorAll('[data-collapsible-tab-visibility]')).map((element) => element.id);
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `restock-data-${this.dataset.section}`, ...this.getCollapsibleTabsToRender()];
    }

    getSelectedProductUrl(event) {
      const target = event?.target;
      if (target?.dataset?.productUrl) return target.dataset.productUrl;
      if (target?.selectedOptions?.[0]?.dataset?.productUrl) return target.selectedOptions[0].dataset.productUrl;
      return this.dataset.url;
    }

    urlsAreSame(a, b) {
      if (!a || !b) return true;
      const normalize = (url) => {
        try {
          return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
        } catch (error) {
          return url;
        }
      };
      return normalize(a) === normalize(b);
    }

    buildProductInfoUrl(productUrl, optionValueIds) {
      const url = new URL(productUrl || this.dataset.url, window.location.origin);
      if (this.dataset.section) url.searchParams.set('section_id', this.dataset.section);
      if (optionValueIds) url.searchParams.set('option_values', optionValueIds);
      return url.toString();
    }

    refreshPickerDataFromHtml(html) {
      html.querySelectorAll('variant-selects[data-block-id]').forEach((freshRoot) => {
        const liveRoot = document.querySelector(`variant-selects[data-block-id="${freshRoot.dataset.blockId}"]`);
        if (!liveRoot) return;

        ['data-selected-variant', 'data-option-availability', 'data-variant-shipping-properties'].forEach((attr) => {
          const freshScript = freshRoot.querySelector(`[${attr}]`);
          const localScript = liveRoot.querySelector(`[${attr}]`);
          if (freshScript && localScript) localScript.textContent = freshScript.textContent;
        });

        liveRoot.currentVariant = liveRoot.getServerSelectedVariant();
        liveRoot.applyOptionAvailability(liveRoot.getOptionAvailabilityData());
        liveRoot.markSelectedAvailability();
      });
    }

    renderProductInfo(event) {
      const sections = this.getSectionsToRender();
      const optionValueIds = (this.optionValueIds || []).filter(Boolean).join(',');
      const productUrl = this.getSelectedProductUrl(event);

      if (productUrl && this.dataset.url && !this.urlsAreSame(productUrl, this.dataset.url)) {
        const nextUrl = new URL(productUrl, window.location.origin);
        if (optionValueIds) nextUrl.searchParams.set('option_values', optionValueIds);
        window.location.assign(`${nextUrl.pathname}${nextUrl.search}`);
        return;
      }

      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(this.buildProductInfoUrl(productUrl, optionValueIds), { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }
          });

          // Each block on the section (color swatches, size picker, etc.) renders its own
          // .variations wrapper in its own <variant-selects>, with a per-block id — so
          // there's more than one, and changing an option in one must refresh the others'
          // (their value.variant depends on this element's newly selected value too).
          document.querySelectorAll(`[id^="variations-${this.dataset.section}-"]`).forEach((destination) => {
            const source = html.getElementById(destination.id);
            if (!source) return;
            destination.innerHTML = source.innerHTML;
            if (typeof window.initColorOptionSwatchGroups === 'function') {
              window.initColorOptionSwatchGroups(destination);
            }
          });

          this.updateOptions();
          this.refreshPickerDataFromHtml(html);
          this.currentVariant = this.getServerSelectedVariant();
          this.updateVariantInput();

          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
          } else {
            this.updateMedia();
            if (this.updateUrl) this.updateURL();
            this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          }

          this.markSelectedAvailability();
          this.resetStickyFormQuantity();
          this.updatePickupAvailability();
          this.loadRestockDataByVariant();
          this.getInventoryByLocation();

          dispatchCustomEvent('product:variant-change', {
            variant: this.currentVariant,
            sectionId: this.dataset.section
          });
          dispatchCustomEvent('product:collapsible-tabs-updated', {
            variant: this.currentVariant,
            sectionId: this.dataset.section
          });
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error(error);
        });
    }

    resetStickyFormQuantity() {
      // Find the sticky add-to-cart form
      const stickyForm = document.querySelector('#product-form--sticky');
      if (!stickyForm) return;

      // Find the quantity input in the sticky form
      const stickyQtyInput = stickyForm.querySelector('.qty');
      if (!stickyQtyInput) return;

      // Get the min value (default to 1 if not set)
      const min = parseInt(stickyQtyInput.min) || 1;
      stickyQtyInput.value = min;

      // Update button states for the quantity selector
      const quantitySelector = stickyQtyInput.closest('quantity-selector');
      if (quantitySelector && quantitySelector.validateQtyRules) {
        quantitySelector.validateQtyRules();
      }

      // Check backorder status
      if (quantitySelector && quantitySelector.checkBackorderStatus) {
        quantitySelector.checkBackorderStatus();
      }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      // Find any product-form element to get the template (both main and sticky should have the same template)
      const productFormElement = document.querySelector(`product-form[data-section="${this.dataset.section}"]`);
      if (!productFormElement) return;

      const productTemplate = productFormElement.getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading', 'sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      this.applyOptionAvailability(this.getOptionAvailabilityData());
      this.markSelectedAvailability();
    }

    markSelectedAvailability() {
      const comboUnavailable = Boolean(this.currentVariant) && this.currentVariant.available === false;
      const fieldsets = this.fieldsets || this.querySelectorAll('fieldset');
      fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) return;
        const checked = fieldset.querySelector('input:checked');
        if (checked) checked.classList.toggle('is-disabled', comboUnavailable);
      });
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    getVariantData() {
      if (this.variantData) return this.variantData;
      const el = this.querySelector('[data-variants-json]');
      if (!el) {
        this.variantData = [];
        return this.variantData;
      }
      try {
        this.variantData = JSON.parse(el.textContent);
      } catch (error) {
        this.variantData = [];
      }
      return this.variantData;
    }

    getOptionAvailabilityData() {
      const el = this.querySelector('[data-option-availability]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return [];
      }
    }

    getServerSelectedVariant() {
      const el = this.querySelector('[data-selected-variant]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    applyOptionAvailability(data) {
      const availabilityById = new Map((data || []).map((entry) => [String(entry.id), entry.available]));
      const disableUnavailable = this.isDisabledFeature == 'true';
      this.querySelectorAll('[data-option-value-id]').forEach((el) => {
        if (!availabilityById.has(el.dataset.optionValueId)) return;
        const available = availabilityById.get(el.dataset.optionValueId);
        el.dataset.available = String(available);
        if (!disableUnavailable) return;
        if (el.tagName === 'OPTION') {
          el.disabled = !available;
        } else {
          el.classList.toggle('is-disabled', !available);
        }
      });
    }

    async getInventoryByLocation() {
      if (!this.currentVariant) return;

      this.showInventoryLoadingSpinner();

      try {
        const shopDomain = window.Shopify?.shop || '';
        const url = `https://asi-inventory-location-app.gadget.app/inventory?variantId=${this.currentVariant.id}&shop=${shopDomain}`;
        const response = await fetch(url, { cache: 'no-store' });
        const data = await response.json();

        const inventoryByLocation = data.inventoryByLocation;
        
        // Render inventory data into the snippet
        this.renderInventoryByLocation(inventoryByLocation);
      } catch (error) {
        console.error('Error fetching inventory by location:', error);
        this.renderInventoryByLocation(null, error);
      }
    }

    showInventoryLoadingSpinner() {
      const container = document.getElementById(`inventory-by-location-${this.dataset.section}`);
      if (!container) return;

      container.innerHTML = `
        <div class="inventory-by-location__spinner">
          <div class="spinner"></div>
          <p>Loading inventory...</p>
        </div>
      `;
    }

    renderInventoryByLocation(inventoryByLocation, error = null) {
      const container = document.getElementById(`inventory-by-location-${this.dataset.section}`);
      if (!container) return;

      if (error) {
        container.innerHTML = '<div class="inventory-by-location__error">Unable to load inventory information.</div>';
        this.updateTotalAvailable(0);
        return;
      }

      if (!inventoryByLocation || (Array.isArray(inventoryByLocation) && inventoryByLocation.length === 0)) {
        container.innerHTML = '<div class="inventory-by-location__empty">No inventory information available.</div>';
        this.updateTotalAvailable(0);
        return;
      }

      // Get location groups from data attribute
      const locationGroupsText = container.dataset.locationGroups || '';
      if (!locationGroupsText.trim()) {
        container.innerHTML = '<div class="inventory-by-location__empty">No location groups configured.</div>';
        this.updateTotalAvailable(0);
        return;
      }

      // Calculate total available across all locations
      let totalAvailable = 0;
      if (Array.isArray(inventoryByLocation)) {
        inventoryByLocation.forEach((location) => {
          const available = location.available !== undefined ? location.available : 0;
          totalAvailable += available;
        });
      }

      // Update the total available in the heading
      this.updateTotalAvailable(totalAvailable);

      // Parse location groups
      const locationGroups = this.parseLocationGroups(locationGroupsText);
      
      // Get restock data for current variant from the pre-loaded object
      const restockData = this.getRestockDataForCurrentVariant();
      
      // Create a map of locationId to location data for quick lookup
      const locationMap = new Map();
      if (Array.isArray(inventoryByLocation)) {
        inventoryByLocation.forEach((location) => {
          const locationId = location.locationId || location.id;
          if (locationId) {
            locationMap.set(String(locationId), location);
          }
        });
      }

      // Build HTML for location groups
      let html = '';
      
      locationGroups.forEach((group) => {
        const quickShipLocation = locationMap.get(String(group.quickShipId));
        const canMakeLocation = locationMap.get(String(group.canMakeId));
        // restockData from variant metafield should be an array, ensure it is
        const restockDataArray = Array.isArray(restockData) ? restockData : (restockData ? [restockData] : []);
        const restockInfo = this.findRestockForLocation(group.label, restockDataArray);
        
        html += this.buildLocationGroupHTML(group, quickShipLocation, canMakeLocation, restockInfo);
      });
      
      container.innerHTML = html;
      
      // Update my-warehouse link with selected location
      this.updateMyWarehouseLink();
    }

    getSelectedLocationName() {
      try {
        const selectedLocationJson = localStorage.getItem('selectedLocation');
        if (!selectedLocationJson) {
          return null;
        }
        
        const selectedLocation = JSON.parse(selectedLocationJson);
        let locationName = selectedLocation.name || '';
        
        // Remove "Can Make" from the location name
        locationName = locationName.replace(/\s*Can Make\s*/gi, '').trim();
        
        return locationName;
      } catch (error) {
        console.error('Error getting selected location name:', error);
        return null;
      }
    }

    updateMyWarehouseLink() {
      const myWarehouseDiv = document.querySelector('.inventory-details-selected-warehouse');
      if (!myWarehouseDiv) return;
      
      const link = myWarehouseDiv.querySelector('a');
      if (!link) return;
      
      const locationName = this.getSelectedLocationName();
      if (locationName) {
        link.textContent = locationName;
      }

      // Sync "selected" styling in inventory-by-location groups whenever the warehouse changes
      this.updateInventoryByLocationSelectedGroup();
      
      // Set up click handler to trigger warehouse-selector button (only once)
      if (!link.dataset.warehouseSelectorHandlerAdded) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.openWarehouseSelectorModal();
        });
        link.dataset.warehouseSelectorHandlerAdded = 'true';
      }
    }

    updateInventoryByLocationSelectedGroup() {
      // Scope to this product section so we don't accidentally update other instances
      const inventoryOptions = document.getElementById(`inventory-by-location-${this.dataset.section}`);
      if (!inventoryOptions) return;

      const groups = inventoryOptions.querySelectorAll('.inventory-by-location__group');
      if (!groups.length) return;

      const selectedLocationName = this.getSelectedLocationName();

      // Remove selected from all, then add to the matching one
      let matched = false;
      groups.forEach((groupEl) => {
        groupEl.classList.remove('selected');

        const labelSpan = groupEl.querySelector('.inventory-by-location__group-header span');
        const rawLabel = (labelSpan?.textContent || '').trim();
        const groupLabel = rawLabel.replace(/:$/, '').trim();

        if (groupLabel && groupLabel === selectedLocationName) {
          groupEl.classList.add('selected');
          matched = true;
        }
      });
    }

    updateTotalAvailable(total) {
      const inventorySection = document.getElementById(`inventory-by-location-${this.dataset.section}`);
      if (!inventorySection) return;
      
      const parentContainer = inventorySection.closest('.inventory-by-location');
      if (!parentContainer) return;
      
      const heading = parentContainer.querySelector('.inventory-by-location__heading span');
      if (heading) {
        heading.textContent = total;
      }
    }

    parseLocationGroups(locationGroupsText) {
      const lines = locationGroupsText.trim().split('\n');
      return lines
        .filter(line => line.trim())
        .map(line => {
          const parts = line.split('|');
          if (parts.length >= 3) {
            return {
              label: parts[0].trim(),
              quickShipId: parts[1].trim(),
              canMakeId: parts[2].trim()
            };
          }
          return null;
        })
        .filter(group => group !== null);
    }

    parseRestockData(restockDataText) {
      if (!restockDataText || !restockDataText.trim()) {
        return [];
      }
      
      try {
        const parsed = JSON.parse(restockDataText);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('Error parsing restock data:', error);
        return [];
      }
    }

    findRestockForLocation(groupLabel, restockData) {
      if (!restockData || !Array.isArray(restockData) || restockData.length === 0) {
        return null;
      }
      
      // Try to find a match by checking if the location name appears in the group label
      // e.g., "West" should match "ASI West"
      const groupLabelLower = groupLabel.toLowerCase();
      
      for (const item of restockData) {
        if (item.location) {
          const locationLower = item.location.toLowerCase();
          // Check if location name is contained in group label (case-insensitive)
          if (groupLabelLower.includes(locationLower) || locationLower.includes(groupLabelLower)) {
            return item.restock || item.restockData || null;
          }
        }
      }
      
      return null;
    }

    buildLocationGroupHTML(group, quickShipLocation, canMakeLocation, restockInfo = null) {
      const quickShipAvailable = quickShipLocation?.available ?? 0;
      const canMakeAvailable = canMakeLocation?.available ?? 0;
      
      // Determine status based on new rules
      let dotClass = '';
      let statusLabel = '';
      
      if (quickShipAvailable > 0) {
        dotClass = 'green';
        statusLabel = 'In Stock';
      } else if (canMakeAvailable > 0) {
        dotClass = 'yellow';
        statusLabel = 'Can Make';
      } else {
        dotClass = 'red';
        statusLabel = 'Out of Stock';
      }
      
      // Check if this group matches the selected location
      const selectedLocationName = this.getSelectedLocationName();
      const isSelected = selectedLocationName && group.label === selectedLocationName;
      const selectedClass = isSelected ? ' selected' : '';
      
      // Format restock information if available
      let restockHTML = '';
      if (restockInfo) {
        const quantity = restockInfo.quantity || 0;
        const estimatedDate = restockInfo.estimatedDate || '';
        const formattedDate = this.formatDate(estimatedDate);
        
        if (quantity > 0 && formattedDate) {
          restockHTML = `
            <div class="inventory-by-location__location restock-info">
            <div class="inventory-by-location__location-available">(${quantity})</div>
              <div class="inventory-by-location__location-label">Estimated Restock ${formattedDate}</div>
            </div>
          `;
        }
      }
      
      return `
        <button type="button" class="inventory-by-location__group${selectedClass}">
          <div class="inventory-by-location__group-header">
            <span>${this.escapeHtml(group.label)}:</span> ${statusLabel}
            <div class="dot ${dotClass}"></div>
          </div>
          <div class="inventory-by-location__group-details">
            <div class="inventory-by-location__location">
              <div class="inventory-by-location__location-available">(${quickShipAvailable})</div>
              <div class="inventory-by-location__location-label">Ready for Quick Ship</div>
            </div>
            ${canMakeAvailable ? `
              <div class="inventory-by-location__location">
                <div class="inventory-by-location__location-available">(${canMakeAvailable})</div>
                <div class="inventory-by-location__location-label">Can Make Custom</div>
              </div>
              ` : ''}
            ${restockHTML}
          </div>
        </button>
      `;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    formatDate(dateString) {
      if (!dateString) return '';
      
      try {
        // Parse YYYY-MM-DD format manually to avoid timezone issues
        // Replace slashes with dashes for consistent parsing
        const normalizedDate = dateString.replace(/\//g, '-');
        const dateMatch = normalizedDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
        
        if (dateMatch) {
          const year = dateMatch[1];
          const month = dateMatch[2];
          const day = dateMatch[3];
          
          // Return formatted as MM/DD/YYYY
          return `${month}/${day}/${year}`;
        }
        
        // If format doesn't match, try using Date object as fallback
        const date = new Date(normalizedDate);
        if (!isNaN(date.getTime())) {
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const year = date.getFullYear();
          return `${month}/${day}/${year}`;
        }
        
        return dateString; // Return original if can't parse
      } catch (error) {
        return dateString; // Return original if error
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.fieldsets = fieldsets;
      this.options = [];
      this.optionValueIds = [];
      fieldsets.forEach((fieldset) => {
        const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        if (!checked) return;
        this.options.push(checked.value);
        this.optionValueIds.push(checked.dataset.optionValueId);
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      // Find the form inside this product-form element instead of by hardcoded ID
      // This allows it to work with both main form and sticky form
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) {
          idInput.disabled = false;
        }
        // Add submit handler for both sticky and non-sticky forms
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      // Get variant ID and quantity from form
      const variantId = this.form.querySelector('input[name="id"]')?.value;
      const quantity = parseInt(this.form.querySelector('input[name="quantity"]')?.value) || 1;

      // Check cart contents and inventory before submitting
      await this.setBackorderPropertyBasedOnCart(variantId, quantity);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      const shippingOrigin = getShippingOriginForLineItem();
      if (shippingOrigin) formData.append('properties[_shipping_origin]', shippingOrigin);
      
      if (typeof getDefaultRateForLineItem === 'function') {
        const defaultRate = getDefaultRateForLineItem();
        if (defaultRate) formData.append('properties[_default_rate]', defaultRate);
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          this.resetQuantitySelectors();

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    async setBackorderPropertyBasedOnCart(variantId, newQuantity) {
      if (!variantId) return;

      
      try {
        // Fetch current cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Find existing line items with the same variant ID
        const existingQuantity = cart.items
          .filter(item => String(item.variant_id) === String(variantId))
          .reduce((sum, item) => sum + item.quantity, 0);

        // Calculate total quantity (existing + new)
        const totalQuantity = existingQuantity + newQuantity;

        // Fetch inventory data
        const shopDomain = window.Shopify?.shop || '';
        const inventoryUrl = `https://asi-inventory-location-app.gadget.app/inventory?variantId=${variantId}&shop=${shopDomain}`;
        const inventoryResponse = await fetch(inventoryUrl, { cache: 'no-store' });
        const inventoryData = await inventoryResponse.json();
        const inventoryByLocation = inventoryData.inventoryByLocation || [];

        // Get selected location from localStorage
        let totalAvailable = 0;
        try {
          const stored = localStorage.getItem('selectedLocation');
          const selectedLocation = stored ? JSON.parse(stored) : null;

          if (selectedLocation && selectedLocation.name) {
            // Strip "Can Make" and "Quick Ship" from the location name
            const strippedName = selectedLocation.name
              .replace(/\bcan make\b/gi, '')
              .replace(/\bquick ship\b/gi, '')
              .replace(/\s+/g, ' ')
              .trim();

            // Find all locations whose locationName contains the stripped name and add up their available values
            inventoryByLocation.forEach((location) => {
              if (location.locationName && location.locationName.includes(strippedName)) {
                totalAvailable += location.available ?? 0;
              }
            });
          }
        } catch (error) {
          console.error('Error getting selected location:', error);
        }

        // Check if total quantity exceeds available inventory
        const shouldBackorder = totalQuantity > totalAvailable;

        // If total will exceed inventory, update existing line items to have backorder=true
        // This ensures they'll merge with the new item that also has backorder=true
        if (shouldBackorder && existingQuantity > 0) {
          const existingItems = cart.items.filter(item => String(item.variant_id) === String(variantId));
          
          // Update each existing line item to have backorder=true
          for (const item of existingItems) {
            const currentProperties = item.properties || {};
            const currentBackorder = currentProperties._backorder;
            
            // Only update if it's not already true
            if (currentBackorder !== 'true' && currentBackorder !== true) {
              const updatedProperties = { ...currentProperties, _backorder: 'true' };
              
              // Update the cart line item
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: item.quantity,
                  properties: updatedProperties
                })
              });
            }
          }
        }

        // Set the backorder property in all product forms for the new item being added
        const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
        productForms.forEach((form) => {
          let backorderInput = form.querySelector('input[name="properties[_backorder]"]');
          
          // Create input if it doesn't exist
          if (!backorderInput) {
            form.insertAdjacentHTML('beforeend', '<input type="hidden" id="backorder" name="properties[_backorder]">');
            backorderInput = form.querySelector('input[name="properties[_backorder]"]');
          }
          
          // Set the value
          backorderInput.value = shouldBackorder ? 'true' : 'false';
        });
      } catch (error) {
        console.error('Error setting backorder property based on cart:', error);
        // On error, default to false
        const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
        productForms.forEach((form) => {
          let backorderInput = form.querySelector('input[name="properties[_backorder]"]');
          if (backorderInput) {
            backorderInput.value = 'false';
          }
        });
      }
    }
    
    resetQuantitySelectors() {
      document.querySelectorAll('form[data-type="add-to-cart-form"] .qty').forEach((qtyInput) => {
        const min = parseInt(qtyInput.min) || 1;
        qtyInput.value = min;

        const quantitySelector = qtyInput.closest('quantity-selector');
        if (quantitySelector && quantitySelector.validateQtyRules) {
          quantitySelector.validateQtyRules();
        }
        if (quantitySelector && quantitySelector.checkBackorderStatus) {
          quantitySelector.checkBackorderStatus();
        }
      });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const sectionHtml = parsedState.sections && parsedState.sections[section.section];
        if (!sectionHtml) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const sectionInnerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (sectionInnerHTML) {
          elementToReplace.innerHTML = sectionInnerHTML;
        }
      });



      let product_drawer = document.getElementById('Product-Modal');

      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : null;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}